const SHOPIFY_HOSTS = ['myshopify.com', 'shopify.com', 'cdn.shopify.com', 'shop.app'];

const isInternal = (link) => {
  const host = link.hostname;
  if (!host || host === location.hostname) return true;
  return SHOPIFY_HOSTS.some((suffix) => host === suffix || host.endsWith(`.${suffix}`));
};

const shouldSkip = (link) => {
  if (link.hasAttribute('target')) return true;
  const href = link.getAttribute('href');
  if (!href) return true;
  if (href.startsWith('#') || href.startsWith('/') || href.startsWith('?')) return true;
  if (/^(mailto|tel|sms|javascript):/i.test(href)) return true;
  return false;
};

const tagExternal = (link) => {
  link.dataset.externalChecked = '1';
  if (shouldSkip(link)) return;
  if (isInternal(link)) return;
  link.setAttribute('target', '_blank');
  const rel = (link.getAttribute('rel') || '').trim();
  const tokens = new Set(rel ? rel.split(/\s+/) : []);
  tokens.add('noopener');
  tokens.add('noreferrer');
  link.setAttribute('rel', Array.from(tokens).join(' '));
};

const scan = (root = document) => {
  for (const link of root.querySelectorAll('a[href]:not([data-external-checked])')) {
    tagExternal(link);
  }
};

const idle = (cb) => (typeof requestIdleCallback === 'function'
  ? requestIdleCallback(cb, { timeout: 1500 })
  : setTimeout(cb, 200));

const queueScan = (root) => idle(() => scan(root));

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => queueScan(), { once: true });
} else {
  queueScan();
}

document.addEventListener('shopify:section:load', (e) => queueScan(e.target));
